/* =============================================================
   ISD product page extras (blocks/isd-product.liquid)
   Small additions that sit next to assets/isd-pdp.js and never edit it.
   - prepared boxes: the first benefit "N produktų vienoje dėžutėje" counts the REAL live bundle components. It reads the list that
     assets/isd-pdp.js builds from the Storefront API (only lists marked data-source="bundle"; the server-rendered fallback lists
     are never counted), so the number is the actual sum of the box components of the selected variant, never a typed number.
     The point stays hidden until that real list exists (or when the request fails).
   Later build passes add their own functions here instead of growing isd-pdp.js.
   ============================================================= */
(function () {
  'use strict';
  if (window.__isdPdpExtras) return;
  window.__isdPdpExtras = true;

  /* Lithuanian noun forms: 1 produktas, 2-9 produktai, 10-20 produktų, 21 produktas ... */
  function pluralLt(n, one, few, many) {
    var m10 = n % 10, m100 = n % 100;
    if (m10 === 1 && m100 !== 11) return one;
    if (m10 === 0 || (m100 >= 11 && m100 <= 19)) return many;
    return few;
  }

  function initLiveCount(root) {
    var li = root.querySelector('[data-isd-live-count]');
    var sec = root.querySelector('[data-isd-live-incl]');
    var out = li && li.querySelector('[data-isd-live-count-text]');
    var chip = root.querySelector('[data-isd-incl-count]');
    var variantInput = root.querySelector('[data-isd-variant-id]');
    if (!sec || (!li && !chip)) return;

    function liveSet() {
      var sets = sec.querySelectorAll('.isd-pdp__incl-set[data-source="bundle"]');
      var vid = variantInput ? String(variantInput.value) : '';
      var found = null;
      [].forEach.call(sets, function (s) { if (s.getAttribute('data-isd-for') === vid) found = s; });
      return found || (sets.length === 1 ? sets[0] : null);
    }
    function countItems(set) {
      var n = 0;
      [].forEach.call(set.querySelectorAll('.isd-pdp__incl-item'), function (item) {
        var q = item.querySelector('.isd-pdp__incl-qty');
        var k = q ? parseInt((q.textContent || '').replace(/\D/g, ''), 10) : 1;
        n += k > 0 ? k : 1;
      });
      return n;
    }
    function show() {
      if (!root.isConnected) return;
      var set = sec.getAttribute('data-state') === 'live' ? liveSet() : null;
      var n = set ? countItems(set) : 0;
      var one = li ? li.getAttribute('data-one') : '', few = li ? li.getAttribute('data-few') : '', many = li ? li.getAttribute('data-many') : '';
      one = one || 'produktas'; few = few || 'produktai'; many = many || 'produktų';
      var lt = /^lt/i.test(document.documentElement.lang || 'lt');
      var unit = n ? (lt ? pluralLt(n, one, few, many) : (n === 1 ? one : few)) : '';
      if (chip) { chip.textContent = n ? n + ' ' + unit : ''; chip.hidden = !n; }
      if (li && out) {
        if (!n) { li.hidden = true; return; }
        out.textContent = (li.getAttribute('data-tpl') || '{n} {unit}').replace('{n}', n).replace('{unit}', unit);
        li.hidden = false;
      }
    }
    show();
    if ('MutationObserver' in window) new MutationObserver(show).observe(sec, { attributes: true, attributeFilter: ['data-state'] });
    document.addEventListener('isd:variant-change', show);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-isd-product]').forEach(function (root) {
      if (root.dataset.isdExtras === '1') return;
      root.dataset.isdExtras = '1';
      initLiveCount(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) { boot(e.target); });
})();
